import * as React from "react"

import { XBlockProps } from "react-xmasonry"
import { IShortcut } from "../../../../models"
import { ITenForceWindow } from "../../../../global"

interface Props extends XBlockProps {
    onNavigate?: () => void
    shortcut: IShortcut
    shouldShowWorkspaceScreenLabel?: boolean
}

declare let window: ITenForceWindow

export default class ShortcutWidget extends React.Component<Props> {
    static defaultProps: Partial<Props> = {
        shouldShowWorkspaceScreenLabel: true,
    }

    render(): JSX.Element {
        const {
            shortcut: { url, title, workspaceLabel },
            shouldShowWorkspaceScreenLabel,
        } = this.props
        return (
            <a
                className="theme-widget tw-mx-2 tw-mb-4 bg-cloud"
                data-ft-shortcut={title.toLowerCase()}
                data-ft-type="shortcut"
                href={!!url ? url : undefined}
                onClick={this.openLink}
            >
                <div className="h5 tw-mt-2" data-ft-component="title">
                    {title}
                </div>
                {shouldShowWorkspaceScreenLabel && !!workspaceLabel && (
                    <div
                        className="text-nickel label is-dimmed"
                        data-ft-component="workspace"
                    >
                        {workspaceLabel}
                    </div>
                )}
            </a>
        )
    }

    openLink = (): void => {
        const {
            shortcut: { linkData },
            onNavigate,
        } = this.props

        if (onNavigate) {
            onNavigate()
        }

        if (!linkData) {
            return
        }
        // We have only two cases to handle click event: CNI and script execution
        if (!linkData.listScriptId) {
            if (!linkData.parentId) {
                window.cni.getInstance().open(linkData.conceptId)
            } else {
                window.cni
                    .getInstance()
                    .setItemForChildItem(
                        linkData.parentId,
                        undefined,
                        linkData.conceptId,
                        false,
                    )
            }
        } else {
            window.scripting.executeItemScript(
                linkData.itemId || null,
                linkData.conceptId || null,
                linkData.collectionId || null,
                linkData.scriptId || null,
                linkData.hasParameters ?? false,
                null,
                null,
                { openResult: true },
                null,
                linkData.listScriptId || null,
            )
        }
    }
}
